export const tenantId= "8b89b65f-d0fd-4e2a-8e9a-acc507e0c118";
export const AUTH_TOKEN = window._env_?.REACT_APP_AUTH_TOKEN ?? process.env.REACT_APP_AUTH_TOKEN;
export const ACCESS_TOKEN_TTL = window._env_?.REACT_APP_ACCESS_TOKEN_TTL ?? process.env.REACT_APP_ACCESS_TOKEN_TTL;
export const ACCESS_TOKEN = window._env_?.REACT_APP_ACCESS_TOKEN ?? process.env.REACT_APP_ACCESS_TOKEN;
export const REFRESH_TOKEN = window._env_?.REACT_APP_REFRESH_TOKEN ?? process.env.REACT_APP_REFRESH_TOKEN;
export const FORGE_UI_URL = window._env_?.REACT_APP_FORGE_UI_URL ?? process.env.REACT_APP_FORGE_UI_URL;
